// import React, { useEffect, useState } from "react";
// import {
//   getAllSubCategories,
//   createSubCategory,
//   updateSubCategory,
//   deleteSubCategory,
// } from "../../../services/adminService"; // ✅ आपकी services

// import { getAllCategories } from "../../../services/adminService"; // ✅ Category list के लिए

// import {
//   Button,
//   Table,
//   Form,
//   Modal,
//   Spinner,
//   Alert,
// } from "react-bootstrap";

// const SubCategoryManagement = () => {
//   const [subCategories, setSubCategories] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [editingSubCategory, setEditingSubCategory] = useState(null);
//   const [formData, setFormData] = useState({
//     name: "",
//     slug: "",
//     description: "",
//     category: "",
//   });

//   // ✅ Load Categories & SubCategories
//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const [subCatRes, catRes] = await Promise.all([
//         getAllSubCategories(),
//         getAllCategories(),
//       ]);
//       setSubCategories(subCatRes.data || []);
//       setCategories(catRes.data || []);
//     } catch (err) {
//       setError(err.message || "Failed to load data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ Handle Input Change
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // ✅ Handle Save (Create/Update)
//   const handleSave = async () => {
//     try {
//       if (editingSubCategory) {
//         await updateSubCategory(editingSubCategory._id, formData);
//       } else {
//         await createSubCategory(formData);
//       }
//       setShowModal(false);
//       setFormData({ name: "", slug: "", description: "", category: "" });
//       setEditingSubCategory(null);
//       fetchData();
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to save subcategory");
//     }
//   };

//   // ✅ Handle Delete
//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this subcategory?")) {
//       try {
//         await deleteSubCategory(id);
//         fetchData();
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to delete subcategory");
//       }
//     }
//   };

//   // ✅ Open Modal for Edit
//   const handleEdit = (subCategory) => {
//     setEditingSubCategory(subCategory);
//     setFormData({
//       name: subCategory.name,
//       slug: subCategory.slug,
//       description: subCategory.description,
//       category: subCategory.category?._id || "",
//     });
//     setShowModal(true);
//   };

//   // ✅ Open Modal for Add
//   const handleAdd = () => {
//     setEditingSubCategory(null);
//     setFormData({ name: "", slug: "", description: "", category: "" });
//     setShowModal(true);
//   };

//   return (
//     <div className="container mt-4">
//       <h3>📂 SubCategory Management</h3>

//       {error && <Alert variant="danger">{error}</Alert>}

//       <Button variant="primary" className="mb-3" onClick={handleAdd}>
//         ➕ Add SubCategory
//       </Button>

//       {loading ? (
//         <Spinner animation="border" />
//       ) : (
//         <Table striped bordered hover>
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Name</th>
//               <th>Slug</th>
//               <th>Description</th>
//               <th>Category</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subCategories.length > 0 ? (
//               subCategories.map((sub, idx) => (
//                 <tr key={sub._id}>
//                   <td>{idx + 1}</td>
//                   <td>{sub.name}</td>
//                   <td>{sub.slug}</td>
//                   <td>{sub.description}</td>
//                   <td>{sub.category?.name || "N/A"}</td>
//                   <td>
//                     <Button
//                       size="sm"
//                       variant="warning"
//                       onClick={() => handleEdit(sub)}
//                     >
//                       ✏️ Edit
//                     </Button>{" "}
//                     <Button
//                       size="sm"
//                       variant="danger"
//                       onClick={() => handleDelete(sub._id)}
//                     >
//                       🗑 Delete
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="6" className="text-center">
//                   No SubCategories Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       {/* ✅ Modal for Create/Update */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {editingSubCategory ? "Edit SubCategory" : "Add SubCategory"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-2">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Enter subcategory name"
//               />
//             </Form.Group>

//             <Form.Group className="mb-2">
//               <Form.Label>Slug</Form.Label>
//               <Form.Control
//                 name="slug"
//                 value={formData.slug}
//                 onChange={handleChange}
//                 placeholder="Enter slug"
//               />
//             </Form.Group>

//             <Form.Group className="mb-2">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 placeholder="Enter description"
//               />
//             </Form.Group>

//             <Form.Group className="mb-2">
//               <Form.Label>Category</Form.Label>
//               <Form.Select
//                 name="category"
//                 value={formData.category}
//                 onChange={handleChange}
//               >
//                 <option value="">-- Select Category --</option>
//                 {categories.map((cat) => (
//                   <option key={cat._id} value={cat._id}>
//                     {cat.name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="success" onClick={handleSave}>
//             Save
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default SubCategoryManagement;

import React, { useEffect, useState } from "react";
import {
  getAllSubCategories,
  createSubCategory,
  updateSubCategory,
  deleteSubCategory,
  getAllCategories,
} from "../../../services/adminService";

import { Button, Table, Form, Modal, Spinner, Alert } from "react-bootstrap";

const SubCategoryManagement = () => {
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingSubCategory, setEditingSubCategory] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    description: "",
    category: "",
  });

  // ✅ Load Categories & SubCategories
  const fetchData = async () => {
    try {
      setLoading(true);
      const [subCatRes, catRes] = await Promise.all([
        getAllSubCategories(),
        getAllCategories(),
      ]);
      setSubCategories(subCatRes.data || []);
      setCategories(catRes.data || []);
    } catch (err) {
      setError(err.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handle Save (Create/Update)
  const handleSave = async () => {
    try {
      if (editingSubCategory) {
        await updateSubCategory(editingSubCategory._id, formData);
      } else {
        await createSubCategory(formData);
      }
      setShowModal(false);
      setFormData({ name: "", slug: "", description: "", category: "" });
      setEditingSubCategory(null);
      fetchData();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save subcategory");
    }
  };

  // ✅ Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this subcategory?")) {
      try {
        await deleteSubCategory(id);
        fetchData();
      } catch (err) {
        setError(err.response?.data?.message || "Failed to delete subcategory");
      }
    }
  };

  // ✅ Open Modal for Edit
  const handleEdit = (subCategory) => {
    setEditingSubCategory(subCategory);
    setFormData({
      name: subCategory.name,
      slug: subCategory.slug,
      description: subCategory.description,
      category: subCategory.category?._id || "",
    });
    setShowModal(true);
  };

  // ✅ Open Modal for Add
  const handleAdd = () => {
    setEditingSubCategory(null);
    setFormData({ name: "", slug: "", description: "", category: "" });
    setShowModal(true);
  };

  // ✅ Group subcategories by Category
  const groupedSubCategories = subCategories.reduce((acc, sub) => {
    const catName = sub.category?.name || "Uncategorized";
    if (!acc[catName]) acc[catName] = [];
    acc[catName].push(sub);
    return acc;
  }, {});

  return (
    <div className="container mt-4">
      <h3>📂 SubCategory Management</h3>

      {error && <Alert variant="danger">{error}</Alert>}

      <Button variant="primary" className="mb-3" onClick={handleAdd}>
        ➕ Add SubCategory
      </Button>

      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Slug</th>
    
              <th>Actions</th>
            </tr>
          </thead>
         <tbody>
  {Object.keys(groupedSubCategories).length > 0 ? (
    // ✅ Sort category names alphabetically
    Object.keys(groupedSubCategories)
      .sort((a, b) => a.localeCompare(b))
      .map((catName, idx) => {
        const subs = groupedSubCategories[catName];
        return (
          <React.Fragment key={idx}>
            {/* Category Row */}
            <tr style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
              <td colSpan="5">📌 {catName}</td>
            </tr>

            {/* Subcategories under that Category */}
            {subs.map((sub, i) => (
              <tr key={sub._id}>
                <td>{i + 1}</td>
                <td>{sub.name}</td>
                <td>{sub.slug}</td>
                <td>
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={() => handleEdit(sub)}
                  >
                    ✏️ Edit
                  </Button>{" "}
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => handleDelete(sub._id)}
                  >
                    🗑 Delete
                  </Button>
                </td>
              </tr>
            ))}
          </React.Fragment>
        );
      })
  ) : (
    <tr>
      <td colSpan="5" className="text-center">
        No SubCategories Found
      </td>
    </tr>
  )}
</tbody>

        </Table>
      )}
{/* ✅ Modal for Create/Update */}
<Modal 
  show={showModal} 
  onHide={() => setShowModal(false)} 
  centered 
  size="md" 

>
  <Modal.Header 
    closeButton 
    className="bg-primary text-white"
  >
    <Modal.Title className="fw-semibold">
      {editingSubCategory ? "✏️ Edit SubCategory" : "➕ Add SubCategory"}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="p-4">
    <Form>
      {/* Name */}
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Name</Form.Label>
        <Form.Control
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter subcategory name"
        />
      </Form.Group>

      {/* Slug */}
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Slug</Form.Label>
        <Form.Control
          name="slug"
          value={formData.slug}
          onChange={handleChange}
          placeholder="Enter slug"
        />
      </Form.Group>



      {/* Category */}
      <Form.Group className="mb-2">
        <Form.Label className="fw-semibold">Category</Form.Label>
        <Form.Select
          name="category"
          value={formData.category}
          onChange={handleChange}
        >
          <option value="">-- Select Category --</option>
          {categories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Form>
  </Modal.Body>

  <Modal.Footer className="d-flex justify-content-between">
    <Button 
      variant="outline-secondary" 
      onClick={() => setShowModal(false)}
    >
      ❌ Cancel
    </Button>
    <Button 
      variant="success" 
      className="px-4 fw-semibold"
      onClick={handleSave}
    >
      💾 Save
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default SubCategoryManagement;

